import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { AutoCompleteTextBoxComponent } from './auto-complete-text-box.component';
@NgModule({
  declarations: [
    [AutoCompleteTextBoxComponent]
  ],
  imports: [CommonModule,FormsModule,ReactiveFormsModule],
 
  exports: [
    AutoCompleteTextBoxComponent,
  ]
})
export class AutoCompleteTextBoxModule { }